export default "__VITE_ASSET__seDaDpu4__"